// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tSSot3ZF","title":"_2XOpncVZ","date":"_3PvXMtC6 flex","label":"_13X_3Tpi flex-auto","icon":"_2HLxddCq"};